var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_2344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 23.3594C8.47487 23.3594 9.0625 22.7228 9.0625 21.9375C9.0625 21.1522 8.47487 20.5156 7.75 20.5156C7.02513 20.5156 6.4375 21.1522 6.4375 21.9375C6.4375 22.7228 7.02513 23.3594 7.75 23.3594Z",
    fill: "#176318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.3594C18.2249 23.3594 18.8125 22.7228 18.8125 21.9375C18.8125 21.1522 18.2249 20.5156 17.5 20.5156C16.7751 20.5156 16.1875 21.1522 16.1875 21.9375C16.1875 22.7228 16.7751 23.3594 17.5 23.3594Z",
    fill: "#176318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21562 7.3125H21.0344L18.5594 16.6969C18.4711 17.0375 18.282 17.3372 18.0211 17.55C17.7603 17.7629 17.4422 17.8771 17.1156 17.875H8.13437C7.80783 17.8771 7.4897 17.7629 7.22886 17.55C6.96803 17.3372 6.77893 17.0375 6.69062 16.6969L3.29688 3.83906C3.25203 3.6692 3.1573 3.51981 3.02704 3.41351C2.89677 3.30722 2.73808 3.24981 2.575 3.25H1",
    fill: "#176318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21562 7.3125H21.0344L18.5594 16.6969C18.4711 17.0375 18.282 17.3372 18.0211 17.55C17.7603 17.7629 17.4422 17.8771 17.1156 17.875H8.13437C7.80783 17.8771 7.4897 17.7629 7.22886 17.55C6.96803 17.3372 6.77893 17.0375 6.69062 16.6969L3.29688 3.83906C3.25203 3.6692 3.1573 3.51981 3.02704 3.41351C2.89677 3.30722 2.73808 3.24981 2.575 3.25H1",
    stroke: "#176318",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1770_2344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCart);
export default __webpack_public_path__ + "static/media/HeaderCart.91bdc38e4ca7167f7a5b42d87198f035.svg";
export { ForwardRef as ReactComponent };